
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { defineComponent, toRefs, reactive, onMounted } from 'vue'
import { getList, gabCarQuery, enterpriseViolationSettingQuery } from './api'
import moment from 'moment'
import Edit from './edit.vue'
export default defineComponent({
  components: {
    CSearchList,
    CTable,
    Edit,
  },
  setup() {
    const remoteData1 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        enterpriseViolationSettingQuery({ orgName: val }).then((res) => {
          remoteData1.options = res.data.map((item) => {
            return {
              label: item.orgName,
              value: item.id,
            }
          })
        })
      },
    })
    const remoteData2 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        gabCarQuery({ carNo: val }).then((res) => {
          remoteData2.options = res.data.map((item) => {
            return {
              label: item.value,
              value: item.value,
            }
          })
        })
      },
    })
    const data = reactive({
      inputList: inputList(
        { ...toRefs(remoteData1) },
        { ...toRefs(remoteData2) }
      ),
      ...getIndexConfig(),
      isedit: false,
      isType: '',
    })
    const onToggle = (name, row?) => {
      data[name] = !data[name]
      row && (data.rowData = row)
    }

    // 新增、修改 按钮操作
    const btnHandle = (type, row) => {
      data.rowData = Object.assign({}, row)
      switch (type) {
        case 'edit': {
          data.isType = 'edit'
          onToggle('isedit', data.rowData)
          break
        }
      }
    }

    // 表单组件变量
    const tableConfig = reactive({
      ...getTableConfig(),
    })
    const dateformchange = (dateTimeString) => {
      if (!dateTimeString) {
        return '' // 如果是空，返回空字符串
      }
      return moment(dateTimeString).format('YYYY-MM-DD')
    }
    /**
     * @description:列表接口
     * @return {void}
     */
    const getListApi = () => {
      const obj = Object.assign(
        { ...data.queryForm },
        {
          currPage: tableConfig.pagination.currentPage,
          pageSize: tableConfig.pagination.pageSize,
        }
      )
      getList(obj).then((res) => {
        tableConfig.data = res.data.list
        tableConfig.pagination.total = res.data.total
      })
    }
    /**
     * @description: 重置事件
     * @param {*} val
     * @return {void}
     */
    const handleReset = (val: object) => {
      data.queryForm = val
      // getListApi()
      // console.log(val)
    }
    /**
     * @description: 查询事件
     * @param {*} params
     * @return {viod}
     */
    const handleSearch = (params: object) => {
      tableConfig.pagination.currentPage = 1
      data.queryForm = Object.assign({}, params)
      getListApi()
    }
    /**
     * @description: 翻页
     * @param {*} val  当前页数
     * @return {void}
     */
    const pageCurrentChange = (val: number) => {
      tableConfig.pagination.currentPage = val
      getListApi()
    }
    /**
     * @description: 每页条数
     * @param {*} val 数量
     * @return {void}
     */
    const pageSizeChange = (val: number) => {
      tableConfig.pagination.currentPage = 1
      tableConfig.pagination.pageSize = val
      getListApi()
    }
    onMounted(() => {
      getListApi()
    })
    return {
      handleReset,
      handleSearch,
      pageCurrentChange,
      pageSizeChange,
      tableConfig,
      ...toRefs(data),
      dateformchange,
      btnHandle,
    }
  },
})
